const getOS = () => {
  let detectOS = 'Unknown OS'

  if (navigator.appVersion.indexOf('Win') !== -1) { detectOS = 'Windows' }

  if (navigator.appVersion.indexOf('Mac') !== -1) { detectOS = 'MacOS' }

  if (navigator.appVersion.indexOf('Linux') !== -1) { detectOS = 'Linux' }

  return detectOS
}

const isMacOS = () => {
  return getOS() === 'MacOS'
}

export default {
  isMacOS,
}
